export const QuinnRole = {
    User: "user",
    Quinn: "quinn",
} as const;

export type QuinnRole = (typeof QuinnRole)[keyof typeof QuinnRole];

export const QuinnTraceStepStatus = {
    Running: "running",
    Done: "done",
    Skipped: "skipped",
    Failed: "failed",
} as const;

export type QuinnTraceStepStatus = (typeof QuinnTraceStepStatus)[keyof typeof QuinnTraceStepStatus];

export const QuinnTraceStepKind = {
    Interpret: "interpret",
    SearchTransactions: "search_transactions",
    MonthlyOverview: "monthly_overview",
    Forecast: "forecast",
    DocumentSearch: "document_search",
    Reasoning: "reasoning",
    Compose: "compose",
} as const;

export type QuinnTraceStepKind = (typeof QuinnTraceStepKind)[keyof typeof QuinnTraceStepKind];

export const QuinnScopeMode = {
    Client: "client",
    AllClients: "all",
} as const;

export type QuinnScopeMode = (typeof QuinnScopeMode)[keyof typeof QuinnScopeMode];

export const QuinnPromptOptionKind = {
    Choice: "choice",
    Business: "business",
    Confirm: "confirm",
} as const;

export type QuinnPromptOptionKind = (typeof QuinnPromptOptionKind)[keyof typeof QuinnPromptOptionKind];

export const QuinnRuntimeEventType = {
    ChatStarted: "chat.started",
    StepStarted: "step.started",
    StepFinished: "step.finished",
    AnswerDelta: "answer.delta",
    AnswerFinished: "answer.finished",
    Error: "error",
} as const;

export type QuinnRuntimeEventType = (typeof QuinnRuntimeEventType)[keyof typeof QuinnRuntimeEventType];

export const ChatHistoryGroup = {
    Today: "Vandaag",
    Yesterday: "Gisteren",
    ThisWeek: "Deze week",
    Earlier: "Eerder",
} as const;

export type ChatHistoryGroup = (typeof ChatHistoryGroup)[keyof typeof ChatHistoryGroup];

export const CHAT_HISTORY_GROUP_ORDER: readonly ChatHistoryGroup[] = [
    ChatHistoryGroup.Today,
    ChatHistoryGroup.Yesterday,
    ChatHistoryGroup.ThisWeek,
    ChatHistoryGroup.Earlier,
];

export const QuinnChartType = {
    Bar: "bar",
    Line: "line",
    Pie: "pie",
} as const;

export type QuinnChartType = (typeof QuinnChartType)[keyof typeof QuinnChartType];

export const QUINN_CHART_TYPES: readonly QuinnChartType[] = [
    QuinnChartType.Bar,
    QuinnChartType.Line,
    QuinnChartType.Pie,
];

export const QuinnColourKey = {
    Inflow: "inflow",
    Outflow: "outflow",
    Neutral: "neutral",
} as const;

export type QuinnColourKey = (typeof QuinnColourKey)[keyof typeof QuinnColourKey];

export const QuinnKpiTrend = {
    Up: "up",
    Down: "down",
    Flat: "flat",
} as const;

export type QuinnKpiTrend = (typeof QuinnKpiTrend)[keyof typeof QuinnKpiTrend];

export const QuinnCopy = {
    SelectClient: "Kies een klant",
    AllClients: "Alle klanten",
    LoadingClients: "Klanten laden…",
    NoClient: "Geen klant",
    CurrentChat: "Huidig gesprek",
    NewChat: "Nieuw gesprek",
    JustNow: "nu",
    GenericError: "Er ging iets mis bij het ophalen van het antwoord. Probeer het opnieuw.",
    NoDescription: "Geen omschrijving",
    UnknownDocument: "Onbekend document",
    OpenDocumentInNewTab: "Open het document in een nieuw tabblad",
    DefaultSeriesName: "waarde",
    Quinn: "Quinn",
    Fullscreen: "Volledig scherm",
    ShrinkToDrawer: "Verkleinen naar zijpaneel",
    BackToOverview: "Terug naar Overzicht",
    SearchChats: "Zoek in gesprekken",
    NoChatsFound: "Geen gesprekken gevonden",
    ShowChatHistory: "Gesprekken tonen",
    HideChatHistory: "Gesprekken verbergen",
    ChatHistory: "Gesprekken",
    Chart: "Grafiek",
    Table: "Tabel",
    ChartPoint: "punt",
    ChartPoints: "punten",
    TableRow: "rij",
    TableRows: "rijen",
    OpenArtifact: "Openen",
    ArtifactOpened: "Geopend",
    ShowCanvas: "Canvas tonen",
    HideCanvas: "Canvas verbergen",
    CloseCanvas: "Canvas sluiten",
    Canvas: "Canvas",
    AskAboutArtifact: "Stel een vraag over dit element…",
    AskAboutArtifactLabel: "Vraag over dit element",
    SendQuestion: "Vraag versturen naar het gesprek",
    About: "Over",
    AnswerAppearsInThread: "Het antwoord verschijnt in dit gesprek",
    OpenDocument: "Document openen",
} as const;

export const QUINN_OVERLAY_BREAKPOINT_PX = 1280;
export const QUINN_CHAT_TITLE_MAX_LENGTH = 46;
export const QUINN_KPI_MAX_COLUMNS = 3;
export const QUINN_CHART_HEIGHT_PX = 220;
export const QUINN_CHART_PIE_OUTER_RADIUS = 80;
export const QUINN_CHART_Y_AXIS_WIDTH = 64;
export const QUINN_CHART_LINE_STROKE_WIDTH = 2;
export const QUINN_CHART_DOT_RADIUS = 3;
export const QUINN_CHART_BAR_RADIUS = 4;
export const DEFAULT_CURRENCY = "EUR";
export const DAY_MS = 24 * 60 * 60 * 1000;

export function isQuinnChartType(value: unknown): value is QuinnChartType {
    return typeof value === "string" && (QUINN_CHART_TYPES as readonly string[]).includes(value);
}
